import React, { useState } from "react";
import {
  Stack,
  Typography,
  IconButton,
  Avatar,
  Popover,
  Button,
} from "@mui/material";
import { FaDisplay } from "react-icons/fa6";
import {
  VideoCamera,
  DotsThreeOutlineVertical,
  Screencast,
  XCircle,
  WhatsappLogo,
  PaperPlaneTilt,
  PaperPlaneRight,
  ArrowsMerge,
  GitMerge,
  Bell,
} from "@phosphor-icons/react";
import { BiSolidCommentX } from "react-icons/bi";
import { connect } from "react-redux";
import {
  setUserlistShow,
  EndChat,
  setExternalChatData,
  setShowChatFullScreen,
} from "../../../../../Redux/Actions/actions";
import Tooltip from "@mui/material/Tooltip";
import EndChatModel from "../../chat-component-model/End-chat-model";
import ConferanceSupervisorModel from "../../chat-component-model/Conferance-supervisor-model";
import ConferanceAgentModel from "../../chat-component-model/Conferance-agent-model";
import TransferSupervisorModel from "../../chat-component-model/Transfer-supervisor-model";
import TransferAgentModel from "../../chat-component-model/Transfer-agent-model";
import WhatsappModal from "../../chat-component-model/Whatsapp-model";
import Cobrowser from "../../chat-component-model/Co-browser";
import {
  BaseUrl,
  CoBroswseUrl,
} from "../../../../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { toaststyle } from "../../../../../Utils/toaststyle";
import { FiMaximize2, FiMinimize2 } from "react-icons/fi";


const mapStateToProps = (state) => {
  const { data, contactListData,chatReducer } = state;
  return {
    userlistshow: data.userlistshow,
    externalChatData: contactListData.externalChatData,
    showChatFullScreen: chatReducer.showChatFullScreen,
  };
};

const WebChatConversationHeader = (props) => {
  const { handleSendMsg } = props;
  const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
  let permission = JSON.parse(localStorage.getItem("permission"));

  const [transferagentmodalDialog, settransferagentmodalDialog] =
    useState(false);
  const [transferSupervisorModalDialog, settransferSupervisorModalDialog] =
    useState(false);
  const [whatsappModalDialogOpen, setwhatsappModalDialogOpen] = useState(false);
  const [conferenceagentModalDialog, setconferenceagentModalDialog] =
    useState(false);
  const [conferenceSupervisorModalDialog, setconferenceSupervisorModalDialog] =
    useState(false);
  const [notificationDialog, setnotificationDialog] = useState(false);
  const [endchatModalDialog, setendchatModalDialog] = useState(false);
  const [showcobrowse, setShowcobrowse] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const transferToAgentDialogClose = () => {
    settransferagentmodalDialog(false);
  };
  const transferToSupervisorDialogClose = () => {
    settransferSupervisorModalDialog(false);
  };
  const transferToWhatsappDialogClose = () => {
    setwhatsappModalDialogOpen(false);
  };
  const ConfrenceToAgentDialogClose = () => {
    setconferenceagentModalDialog(false);
  };
  const ConfrenceToSupervisorDialogClose = () => {
    setconferenceSupervisorModalDialog(false);
  };

  const NotificationHandleDialogClose = () => {
    setnotificationDialog(false);
  };

  const EndChatDialogClose = () => {
    setendchatModalDialog(false);
  };

  const handleCobrowseClose = () => {
    setShowcobrowse(false);
  };

  const CobrosweData = (value) => {
    try {
      let data = {
        url: value,
        agent_id: "313007",
        tags: ["tag1", "tag2"],
        hide_selector:
          "#input1,#input2,#emailID,#empAadhaar,#uan,#cust_PAN, #mobileinfo_Pan",
      };
      axios
        .post(CoBroswseUrl, data)
        .then((res) => {
          let url = res.data.leader_link;
          var width = 500;
          var height = 400;
          var left = (window.innerWidth - width) / 2;
          var top = (window.innerHeight - height) / 2;
          window.open(
            url,
            "Popup",
            "width=" +
              width +
              ", height=" +
              height +
              ", left=" +
              left +
              ", top=" +
              top
          );
          setShowcobrowse(false);
          handleSendMsg(res.data.follower_link, "TEXT", "");
        })
        .catch((err) => {
          console.log("err", err);
        });
    } catch (error) {}
  };
  const CobrosweData2 = async (value, type) => {
    await axios
      .post(
        CoBroswseUrl + "cobrowseapi",
        {
          email: type == "Email" ? "Email" : "",
          phonenumber: type == "Phone" ? "Phone" : "",
          url: value,
          type: type,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Tenantid: localStorage.getItem("TenantId"),
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
        }
      )
      .then((res) => {
        if (res.data.status == true) {
          let url = res.data.leader_link;
          var width = 500;
          var height = 400;
          var left = (window.innerWidth - width) / 2;
          var top = (window.innerHeight - height) / 2;
          window.open(
            url,
            "Popup",
            "width=" +
              width +
              ", height=" +
              height +
              ", left=" +
              left +
              ", top=" +
              top
          );
          setShowcobrowse(false);
          window.open(res.data.leader_link);
        } else {
          toast.warn("something went wrong");
        }
      })
      .catch((err) => {});
  };
  const ActivateVideoCallChat = () => {
    axios
      .post(
        BaseUrl + "/users/videourl",
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          let url = res.data.leader_link;
          var width = 500;
          var height = 400;
          var left = (window.innerWidth - width) / 2;
          var top = (window.innerHeight - height) / 2;
          window.open(
            url,
            "Popup",
            "width=" +
              width +
              ", height=" +
              height +
              ", left=" +
              left +
              ", top=" +
              top
          );
          handleSendMsg(res.data.follower_link, "TEXT", "");
          handleClose();
        } else {
          toast.warn("No Data Found", toaststyle);
          handleClose();
        }
      })
      .catch((error) => {
        console.log("AgentContact", error);
      });
  };

  return (
    <>
      <Stack
        sx={{
          height: "max-content",
          width: "100%",
          borderRadius: "0 7px 0 0",
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          background: "white",
          zIndex: "999",
        }}
        p={1}
      >
        <Stack
          alignItems={"center"}
          direction={"row"}
          justifyContent={"space-between"}
          sx={{ width: "100%" }}
        >
          <Stack direction={"row"} sx={{ width: "100%" }}>
            <Stack direction={"row"} spacing={1} sx={{ flexGrow: 1 }}>
              <Avatar
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  background: "#0B3363",
                  width: "30px",
                  height: "30px",
                }}
                className="box-inset2"
              >
                {props.externalChatData
                  ? props.externalChatData.unique_id
                    ? props.externalChatData.unique_id.username
                      ? props.externalChatData.unique_id.username
                          .slice(0, 2)
                          .toUpperCase()
                      : props.externalChatData.unique_id.phonenumber
                          .slice(0, 2)
                          .toUpperCase()
                    : ""
                  : ""}
              </Avatar>
              <Stack
                spacing={0.1}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 600, fontSize: "13px", width: "130px" }}
                  noWrap
                >
                  {props.externalChatData
                    ? props.externalChatData.unique_id
                      ? props.externalChatData.unique_id.username
                        ? props.externalChatData.unique_id.username
                        : props.externalChatData.unique_id.phonenumber
                      : ""
                    : ""}
                </Typography>
              </Stack>
            </Stack>

            <Stack direction={"row"} alignItems={"center"}>
            <Tooltip
              arrow
              placement="top"
              title={props.showChatFullScreen ? "Minimize" : "Maximize"}
            >
              <IconButton
                onClick={() => {
                  props.setShowChatFullScreen(!props.showChatFullScreen);
                }}
              >
                {props.showChatFullScreen ? (
                  <FiMinimize2 size={17} />
                ) : (
                  <FiMaximize2 size={17} />
                )}
              </IconButton>
            </Tooltip>
              <IconButton
                disabled={
                  props.externalChatData
                    ? props.externalChatData.is_customer_disconnected
                    : ""
                }
                aria-describedby={id}
                onClick={(e) => {
                  handleClick(e);
                }}
              >
                <DotsThreeOutlineVertical size={17} weight="fill" />
              </IconButton>
              <Popover
                sx={{
                  "& .MuiPaper-root": {
                    borderRadius: "30px 0 30px 30px",
                    padding: "7px",
                    width: "max-content",
                  },
                }}
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <Stack direction={"row"} spacing={1}>
                  {props.externalChatData.channel != "from_whatsapp" && (
                    <>
                      {permission.map((module) => {
                        if (module.moduleName === "CHAT_INTERACTION") {
                          const value = module.screen.find(
                            (item) =>
                              item.screenId === "TRANSFER_WHATSAPP" &&
                              item.read &&
                              item.write
                          );

                          if (value) {
                            return (
                              <Tooltip
                                title="Transfer to Whatsapp"
                                arrow
                                placement="top"
                              >
                                <IconButton
                                  onClick={() => {
                                    setwhatsappModalDialogOpen(true);
                                  }}
                                >
                                  <WhatsappLogo size={15} weight="bold" />
                                </IconButton>
                              </Tooltip>
                            );
                          } else {
                            return (
                              <Tooltip
                                title="Contact Admin"
                                arrow
                                placement="top"
                              >
                                <IconButton>
                                  <WhatsappLogo size={15} weight="bold" />
                                </IconButton>
                              </Tooltip>
                            );
                          }
                        }
                      })}
                    </>
                  )}

                  {permission.map((module) => {
                    if (module.moduleName === "CHAT_INTERACTION") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "TRANSFER_AGENT_CHAT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Transfer to Agent"
                            arrow
                            placement="top"
                          >
                            <IconButton
                              onClick={() => {
                                settransferagentmodalDialog(true);
                              }}
                            >
                              <PaperPlaneTilt size={15} weight="bold" />
                            </IconButton>
                          </Tooltip>
                        );
                      } else {
                        return (
                          <Tooltip title="Contact Admin" arrow placement="top">
                            <IconButton>
                              <PaperPlaneTilt size={15} weight="bold" />
                            </IconButton>
                          </Tooltip>
                        );
                      }
                    }
                  })}
                  {permission.map((module) => {
                    if (module.moduleName === "CHAT_INTERACTION") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "TRANSFER_SUPERVISOR_CHAT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Transfer to supervisor"
                            arrow
                            placement="top"
                          >
                            {basedOnRole.role == "Supervisor" ? null : (
                              <IconButton
                                onClick={() => {
                                  settransferSupervisorModalDialog(true);
                                }}
                              >
                                <PaperPlaneRight size={15} weight="bold" />
                              </IconButton>
                            )}
                          </Tooltip>
                        );
                      } else {
                        return (
                          <Tooltip title="Contact Admin" arrow placement="top">
                            {basedOnRole.role == "Supervisor" ? null : (
                              <IconButton>
                                <PaperPlaneRight size={15} weight="bold" />
                              </IconButton>
                            )}
                          </Tooltip>
                        );
                      }
                    }
                  })}
                  {permission.map((module) => {
                    if (module.moduleName === "CHAT_INTERACTION") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "CONFERENCE_AGENT_CHAT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Conference to Agent"
                            arrow
                            placement="top"
                          >
                            <IconButton
                              onClick={() => {
                                setconferenceagentModalDialog(true);
                              }}
                            >
                              <GitMerge size={15} weight="bold" />
                            </IconButton>
                          </Tooltip>
                        );
                      } else {
                        return (
                          <Tooltip title="Contact Admin" arrow placement="top">
                            <IconButton>
                              <GitMerge size={15} weight="bold" />
                            </IconButton>
                          </Tooltip>
                        );
                      }
                    }
                  })}
                  {permission.map((module) => {
                    if (module.moduleName === "CHAT_INTERACTION") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "CONFERENCE_SUPERVISOR_CHAT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip
                            title="Conference to Supervisor"
                            arrow
                            placement="top"
                          >
                            {basedOnRole.role == "Supervisor" ? null : (
                              <IconButton
                                onClick={() => {
                                  setconferenceSupervisorModalDialog(true);
                                }}
                              >
                                <ArrowsMerge size={15} weight="bold" />
                              </IconButton>
                            )}
                          </Tooltip>
                        );
                      } else {
                        return (
                          <Tooltip title="Contact Admin" arrow placement="top">
                            {basedOnRole.role == "Supervisor" ? null : (
                              <IconButton>
                                <ArrowsMerge size={15} weight="bold" />
                              </IconButton>
                            )}
                          </Tooltip>
                        );
                      }
                    }
                  })}

                  {permission.map((module) => {
                    if (module.moduleName === "CHAT_INTERACTION") {
                      const value = module.screen.find(
                        (item) =>
                          (item.screenId === "COBROWSE_PURE" &&
                            item.read &&
                            item.write) ||
                          (item.screenId === "COBROWSE" &&
                            item.read &&
                            item.write)
                      );

                      if (value) {
                        return (
                          <Tooltip title="Co-Browse" arrow placement="top">
                            <IconButton
                              onClick={() => {
                                setShowcobrowse(true);
                              }}
                            >
                              <FaDisplay size={15} weight="bold" />
                            </IconButton>
                          </Tooltip>
                        );
                      } else {
                        return <></>;
                      }
                    }
                  })}
                  {permission.map((module) => {
                    if (module.moduleName === "CHAT_INTERACTION") {
                      const value = module.screen.find(
                        (item) =>
                          item.screenId === "VIDEOCHAT" &&
                          item.read &&
                          item.write
                      );

                      if (value) {
                        return (
                          <Tooltip title="Video Call" arrow placement="top">
                            <IconButton
                              disabled={
                                props.externalChatData
                                  ? props.externalChatData
                                      .is_customer_disconnected
                                  : ""
                              }
                              onClick={() => {
                                ActivateVideoCallChat();
                              }}
                            >
                              <VideoCamera size={15} weight="bold" />
                            </IconButton>
                          </Tooltip>
                        );
                      } else {
                        return (
                          <Tooltip title="Contact Admin" arrow placement="top">
                            <IconButton>
                              <VideoCamera size={15} weight="bold" />
                            </IconButton>
                          </Tooltip>
                        );
                      }
                    }
                  })}
                </Stack>
              </Popover>

              {permission.map((module) => {
                if (module.moduleName === "CHAT_INTERACTION") {
                  const value = module.screen.find(
                    (item) =>
                      item.screenId === "END_INTERACTION" &&
                      item.read &&
                      item.write
                  );

                  if (value) {
                    return (
                      <Tooltip title="End Interaction" arrow placement="top">
                        <Button
                          onClick={() => {
                            if (basedOnRole.role == "Supervisor") {
                              if (
                                JSON.parse(localStorage.getItem("client"))
                                  .observeAgent
                              ) {
                                props.EndChat(props.externalChatData);
                              } else {
                                setendchatModalDialog(true);
                                handleClose();
                              }
                            } else {
                              setendchatModalDialog(true);
                              handleClose();
                            }
                          }}
                          className="fs-12 me-1 p-2"
                          variant="contained"
                          disableElevation
                          color="error"
                          size="small"
                          sx={{ textTransform: "capitalize", minWidth: "39px" }}
                        >
                          <BiSolidCommentX />
                        </Button>
                      </Tooltip>
                    );
                  } else {
                    return (
                      <Tooltip title="Contact Admin" arrow placement="top">
                        <Button>
                          <BiSolidCommentX />
                        </Button>
                      </Tooltip>
                    );
                  }
                }
              })}
            </Stack>
          </Stack>
        </Stack>
      </Stack>

      {whatsappModalDialogOpen && (
        <WhatsappModal
          OpenDialog={whatsappModalDialogOpen}
          handleClose={transferToWhatsappDialogClose}
        />
      )}
      {transferagentmodalDialog && (
        <TransferAgentModel
          OpenDialog={transferagentmodalDialog}
          handleClose={transferToAgentDialogClose}
        />
      )}
      {transferSupervisorModalDialog && (
        <TransferSupervisorModel
          OpenDialog={transferSupervisorModalDialog}
          handleClose={transferToSupervisorDialogClose}
        />
      )}
      {conferenceagentModalDialog && (
        <ConferanceAgentModel
          OpenDialog={conferenceagentModalDialog}
          handleClose={ConfrenceToAgentDialogClose}
        />
      )}
      {conferenceSupervisorModalDialog && (
        <ConferanceSupervisorModel
          OpenDialog={conferenceSupervisorModalDialog}
          handleClose={ConfrenceToSupervisorDialogClose}
        />
      )}

      {endchatModalDialog && (
        <EndChatModel
          OpenDialog={endchatModalDialog}
          handleClose={EndChatDialogClose}
        />
      )}
      {showcobrowse && (
        <Cobrowser
          OpenDialog={showcobrowse}
          handleClose={handleCobrowseClose}
          CobrosweData={CobrosweData}
          CobrosweData2={CobrosweData2}
          externalChatData={props.externalChatData}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps, {
  setUserlistShow,
  EndChat,
  setExternalChatData,
  setShowChatFullScreen
})(WebChatConversationHeader);
